import { tableAnatomy } from "@chakra-ui/anatomy";
import { StyleFunctionProps, createMultiStyleConfigHelpers } from "@chakra-ui/react";
import { defineStyle } from "@chakra-ui/styled-system";

import { combineObjects } from "@nens/shared-utils";

import { SIZES } from "../consts/sizing-consts";

// Theming props can be found:
// https://v2.chakra-ui.com/docs/components/table/theming

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  tableAnatomy.keys
);

const DEFAULT_PROPS = {
  th: defineStyle({ fontFamily: "", textTransform: "", letterSpacing: "" }),
};

const baseStyle = definePartsStyle((props: StyleFunctionProps) => {
  const { variant } = props;

  const variantProps = (() => {
    if (variant === "grid")
      return {
        table: defineStyle({
          w: "full",
          color: "brand.deep_sea",
          bg: "brand.bg",
          fontSize: 14,
        }),
        thead: defineStyle({
          color: "brand.analytic",
          bg: "brand.light_sky",
          fontWeight: "bold",
        }),
        td: defineStyle({
          textAlign: "left",
          alignContent: "start",
          p: 4,
          px: `${SIZES[4]} !important`, // override chakra's default padding inline start. Doesnt work any other way...
          borderWidth: "base",
          borderColor: "brand.border",
          position: "relative",
        }),
      };
    return {};
  })();

  return combineObjects(DEFAULT_PROPS, variantProps);
});

export const tableTheme = defineMultiStyleConfig({ baseStyle });
